
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Badge } from "@/components/ui/badge"

interface TeamPerformanceItem {
  id?: string;
  name: string;
  velocity: number;
  completionRate: number | string;
  qualityScore: number;
  tasks?: number;
  previousVelocity?: number;
  previousCycleTime?: number;
  cycleTime?: number;
  status?: string;
}

interface TeamPerformanceTableProps {
  data: TeamPerformanceItem[];
}

export function TeamPerformanceTable({ data }: TeamPerformanceTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Team</TableHead>
            <TableHead className="text-right">Sprint Velocity</TableHead>
            <TableHead className="text-right">Cycle Time (days)</TableHead>
            <TableHead className="text-right">Completion Rate</TableHead>
            <TableHead className="text-right">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((team, index) => {
            const velocityTrend = team.previousVelocity !== undefined ? 
              team.velocity - team.previousVelocity : undefined;
            const cycleTrend = team.previousCycleTime !== undefined && team.cycleTime !== undefined ? 
              team.previousCycleTime - team.cycleTime : undefined;
            
            // Determine status if not provided
            const status = team.status || 
              (typeof team.completionRate === 'number' && team.completionRate > 90 ? "excellent" : 
               typeof team.completionRate === 'number' && team.completionRate > 80 ? "good" : "needs-improvement");
            
            return (
              <TableRow key={team.id || index}>
                <TableCell className="font-medium">{team.name}</TableCell>
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    {team.velocity}
                    {velocityTrend !== undefined && (
                      <span className={velocityTrend >= 0 ? "text-green-600 text-xs" : "text-red-600 text-xs"}>
                        {velocityTrend >= 0 ? `+${velocityTrend}` : velocityTrend}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    {team.cycleTime || "-"}
                    {cycleTrend !== undefined && (
                      <span className={cycleTrend >= 0 ? "text-green-600 text-xs" : "text-red-600 text-xs"}>
                        {cycleTrend >= 0 ? `+${cycleTrend}` : cycleTrend}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right">{team.completionRate}</TableCell>
                <TableCell className="text-right">
                  <Badge 
                    variant={
                      status === "excellent" ? "default" : 
                      status === "good" ? "secondary" : 
                      "destructive"
                    }
                  >
                    {status === "excellent" ? "Excellent" : 
                     status === "good" ? "Good" : 
                     "Needs Improvement"}
                  </Badge>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}
